//@flow
import Constants from '../constants';
import Dispatcher from '../dispatcher';

export default {
  openChat() {
    Dispatcher.dispatchAction(Constants.OPEN_CHAT);
  },

  openChatModal() {
    Dispatcher.dispatchAction(Constants.OPEN_MODAL, Constants.CHAT_INFO_MODAL);
  },

  closeChatModal() {
    Dispatcher.dispatchAction(Constants.CLOSE_MODAL, Constants.CHAT_INFO_MODAL);
  },

  setStatus(status:string) {
    Dispatcher.dispatchAction(Constants.SET_CHAT_STATUS, status);
  },
};
